import WebService from "../WebService";

const Content = {
  gets(params) {
    return WebService.get("/contents/pages" + "?" + params);
  },
  pageDetail(page_id, params) {
    return WebService.get("/contents/pages/" + page_id + "?" + params);
  },
  updatePage(page_id, data) {
    return WebService.post(`/contents/pages/${page_id}`, data);
  },
  uploadPageBanner(page_id, data) {
    return WebService.post(`/contents/pages/${page_id}/upload-banner`, data);
  },
  addPage(data) {
    return WebService.post(`/contents/pages`, data);
  },

  updateContent( data) {
    return WebService.post(`/contents/contents/update`, data);
  },
  addContent(data) {
    return WebService.post(`/contents/contents/create`, data);
  },

};
export default Content;
